<div class="input-action-cell">
  <gains-input
    [required]="isOptionalPanelEnabled"
    [error]="showValidationError"
    [placeholder]="inputPlaceholder"
    [formControl]="formControl"
  ></gains-input>
  <span *ngIf="showValidationError" class="required-label">Required</span>
</div>
